import { Notify } from "../notify";

export default () => ({
    sum: 0,
    count: 1,
    show: true,

    async remove(key) {
        let response = await fetch('/api/cart/' + key, {
            method: 'DELETE',
            headers: {
                'X-csrf-token': _token
            },
        });

        if (!response.ok) {
            Notify.error(lex['form.internal_error']);
            return;
        }

        let result = await response.json();

        if (result.error !== '') {
            Notify.error(result.error);
        } else {
            this.$store.cart.set(result.data);

            this.show = false;

            Notify.success(result.success);

            if(result.data.count === 0) {
                window.location = `${langSlug}/order`
            }
        }
    },

    async changeCount(key) {
        if(this.count < 1) {
            this.count = 1;
        }

        let data = new URLSearchParams({count: this.count});

        let response = await fetch('/api/cart/' + key,{
            method: 'PUT',
            headers: {
                'X-csrf-token': _token
            },
            body: data,
        });

        if (!response.ok) {
            Notify.error(lex['form.internal_error']);
            return;
        }

        let result = await response.json();

        if (result.error !== '') {
            Notify.error(result.error);
        } else {
            this.$store.cart.set(result.data);

            Notify.success(result.success);
        }
    },
})
